import PropTypes from 'prop-types';
import { getPrice } from '../../../../../common/routines/utils';
import { formatDate } from '../../../../../utils/formatters';

const NegativeDueReportRow = ({ slNo, rowData, id, nestedColumnsNumber }) => {
  const { purchaserName, purchaserOPI, particulars } = rowData;
  return (
    <tr key={id} className="table-body-tr">
      <td width="50px" align="center" className="valign-middle">
        {slNo}
      </td>
      <td className="valign-middle">
        <div className="mb-1 display-block">{purchaserOPI}</div>
      </td>
      <td className="valign-middle ar-text-wrap">
        <div className="mb-1 display-block">{purchaserName}</div>
      </td>
      {[...Array(nestedColumnsNumber)]?.map((_col, column) => {
        return (
          <td key={column} className="p-0 tb-next">
            {particulars?.map((rowDataValues, rdIndex) => {
              return (
                <table key={rdIndex} className="inner-table-1">
                  <tbody>
                    {column === 0 && (
                      <tr className="tr-next">
                        <td className="tr-next-1">{rowDataValues?.contractNumber}</td>
                      </tr>
                    )}
                    {column === 1 && (
                      <tr className="tr-next">
                        <td className="tr-next-1">{rowDataValues?.addendumStatus}</td>
                      </tr>
                    )}
                    {column === 2 && (
                      <tr className="tr-next">
                        <td className="tr-next-1">{formatDate(rowDataValues?.submissionDate)}</td>
                      </tr>
                    )}
                    {column === 3 && (
                      <tr className="tr-next">
                        <td className="tr-next-1">{getPrice(rowDataValues?.totalPrice)}</td>
                      </tr>
                    )}
                    {column === 4 && (
                      <tr className="tr-next">
                        <td className="tr-next-1">{getPrice(rowDataValues?.totalTax)}</td>
                      </tr>
                    )}
                    {column === 5 && (
                      <tr className="tr-next">
                        <td className="tr-next-1">{getPrice(rowDataValues?.totalPurchasePrice)}</td>
                      </tr>
                    )}
                    {column === 6 && (
                      <tr className="tr-next">
                        <td className="tr-next-1">{getPrice(rowDataValues?.totalAdjustment)}</td>
                      </tr>
                    )}
                    {column === 7 && (
                      <tr className="tr-next">
                        <td className="tr-next-1">{getPrice(rowDataValues?.totalCashPrice)}</td>
                      </tr>
                    )}
                    {column === 8 && (
                      <tr className="tr-next">
                        <td className="tr-next-1">{getPrice(rowDataValues?.totalPaid)}</td>
                      </tr>
                    )}
                    {column === 9 && (
                      <tr className="tr-next">
                        <td className="tr-next-1">{getPrice(rowDataValues?.due)}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              );
            })}
          </td>
        );
      })}
    </tr>
  );
};

NegativeDueReportRow.propTypes = {
  rowData: PropTypes.shape({
    purchaserName: PropTypes.string.isRequired,
    purchaserOPI: PropTypes.string.isRequired,
    particulars: PropTypes.shape([
      {
        contractNumber: PropTypes.string,
        submissionDate: PropTypes.string,
        totalPrice: PropTypes.number,
        totalCashPrice: PropTypes.number,
        totalTax: PropTypes.number,
        totalPurchasePrice: PropTypes.number,
        totalAdjustment: PropTypes.number,
        totalPaid: PropTypes.number,
        due: PropTypes.number,
      },
    ]).isRequired,
  }).isRequired,
  id: PropTypes.number.isRequired,
  nestedColumnsNumber: PropTypes.number.isRequired,
  slNo: PropTypes.number.isRequired,
};

export default NegativeDueReportRow;
